import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OtherService } from "src/app/Service/other.service";
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { BingMaps, Cluster, OSM, Vector, XYZ } from 'ol/source';
import { Feature, View } from 'ol';
import { MapService } from 'src/app/Service/map.service';
import { Point } from 'ol/geom';
import { Circle, Fill, Stroke, Style, Text } from "ol/style";
import axios from "src/app/Service/axios";
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import TileLayer from 'ol/layer/Tile';
import Map from 'ol/Map';
import AnimatedCluster from 'ol-ext/layer/AnimatedCluster';
import SelectCluster from 'ol-ext/interaction/SelectCluster';
import * as olProj from 'ol/proj';
import { ChartContext } from 'src/app/shared/chart/chart.models';
import { parseCategoryChartData, parseChartTree } from 'src/app/shared/chart/chart-data.utils';
import { PreRegistrationChartKey } from './pre-registration-dashboard.models';
declare let $: any;


@Component({

  selector: 'app-pre-registration-dashboard',

  templateUrl: './pre-registration-dashboard.component.html',

  styleUrls: ['./pre-registration-dashboard.component.css']

})

export class PreRegistrationDashboardComponent implements OnInit, OnDestroy {

  vector: any;

  vector2: any;

  source: any;

  source2: any;

  layers: any = [];

  layers2: any = [];

  ctx7: any;

  ctx8: any;

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private router: Router,


    private otherService: OtherService,

    private gurdService: GurdServiceService,

    private _tooltip: NotificationService,

    private mapService: MapService,

  ) {

  }

  isLoading = false;
  private destroyed = false;

  domainChart: ChartContext = {
    type: 'tree', title: 'آمار به تفکیک حوزه', data: [], loading: true,
  };

  installationStatusChart: ChartContext = {
    type: 'pie', title: 'وضعیت نصب', data: [], loading: true,
  };

  floatingTypeChart: ChartContext = {
    type: 'pie', title: 'پیش ثبت‌نام ها به تفکیک شناور', data: [], loading: true,
  };

  registrationDateChart: ChartContext = {
    type: 'line', title: 'پیش ثبت‌نام ها به تفکیک تاریخ', unit: 'تعداد', zoom: true, colors: ['#FF3333'], data: [], loading: true,
  };

  announcementDateChart: ChartContext = {
    type: 'line', title: 'برنامه نصب به تفکیک تاریخ', unit: 'تعداد', zoom: true, colors: ['#FF3333'], data: [], loading: true,
  };

  installerPlanChart: ChartContext = {
    type: 'bar', title: 'برنامه نصب به تفکیک نصاب', unit: 'تعداد', zoom: true, data: [], loading: true,
  };

  installationDateChart: ChartContext = {
    type: 'bar', title: 'تعداد نصب به تفکیک تاریخ', unit: 'تعداد', zoom: true, data: [], loading: true,
  };

  ngOnInit(): void {
    void this.initialization();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.ctx7?.dispose();
    this.ctx8?.dispose();
  }

  goBack(): void {
    void this.router.navigateByUrl('/');
  }

  async initialization(): Promise<void> {
    if (this.isLoading) return;
    this.isLoading = true;
    this.otherService.Showspinner();
    try {
      await Promise.allSettled([
        this.loadChart('domainChart', 'Preregistration_DashboardBaseDomain'),
        this.loadChart('installationStatusChart', 'Preregistration_InstallationStatusChart', '57'),
        this.loadChart('floatingTypeChart', 'Preregistration_FloatingTypeChart', '57'),
        this.loadChart('registrationDateChart', 'Preregistration_RegisterDatChart', '32'),
        this.loadChart('announcementDateChart', 'Preregistration_AnnouncementDateChart', '32'),
        this.loadChart('installerPlanChart', 'Preregistration_InstallerPlanChart', '21'),
        this.loadChart('installationDateChart', 'Preregistration_InstallDateChart', '21'),
        this.getPreregistration_Map(),
        this.getInstallMap(),
      ]);
    } finally {
      this.isLoading = false;
      this.otherService.nonespinner();
    }
  }

  private async requestReport(api: string, sessionError?: string, normalizeNumbers = false) {
    const model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    };
    const response = await axios.post(api, normalizeNumbers ? this.otherService.stringNumberToNumber(model) : model);
    const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    if (data?.ISSessionExpired === true || data?.ISessionExpired === true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      void this.router.navigate(['login'], sessionError ? { queryParams: { error: sessionError } } : {});
      throw new Error('Dashboard session expired');
    }
    if (data?.iResult == 0) {
      this._tooltip.showError(data.strError);
      throw new Error(data.strError || 'Dashboard request failed');
    }
    return data;
  }

  private async loadChart(chartKey: PreRegistrationChartKey, api: string, sessionError?: string): Promise<void> {
    this[chartKey] = { ...this[chartKey], loading: true, error: undefined };
    try {
      const context = this[chartKey];
      const data = await this.requestReport(api, sessionError, context.type === 'tree');
      this[chartKey] = context.type === 'tree'
        ? { ...context, data: parseChartTree(data) }
        : { ...context, data: parseCategoryChartData(data) };
    } catch (error) {
      this[chartKey] = { ...this[chartKey], error: 'اطلاعات این نمودار دریافت نشد. دوباره به روز رسانی کنید.' };
      throw error;
    } finally {
      this[chartKey] = { ...this[chartKey], loading: false };
    }
  }

  getPreregistration_Map = async () => {

    const res = await this.requestReport('Preregistration_Map');
    if (this.destroyed) return;
    if (!Array.isArray(res)) throw new Error('Invalid map data');
    this.ctx7?.dispose();
    this.layers = [];



    this.source = new VectorSource({ wrapX: false });

    this.vector = new VectorLayer({

      source: this.source,

    });

    if (this.bOfflineMap) {

      this.layers.push(

        new TileLayer({

          source: new XYZ({

            url: this.strMapUrl,

            attributions: 'Map data © RayanAndishehNasr' //

          }),

        })

      );
    }

    else {

      const styles = [

        'AerialWithLabelsOnDemand',

      ];

      let i, ii;

      for (i = 0, ii = styles.length; i < ii; ++i) {
        this.layers.push(
          new TileLayer({
            visible: false,
            preload: Infinity,
            source: new BingMaps({
              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

              imagerySet: styles[i],
            }),

          }),
        );
      }

      this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)
    }

    this.ctx7 = new Map({

      target: "Preregistration_Map",

      view: new View({

        zoom: 4,

        center: olProj.fromLonLat([51.3833554, 35.6770113])

      }),

      layers: this.layers

    });

    await this.clustersLayer(res);


  }

  getInstallMap = async () => {

    const res = await this.requestReport('Preregistration_InstallMap');
    if (this.destroyed) return;
    if (!Array.isArray(res)) throw new Error('Invalid map data');
    this.ctx8?.dispose();
    this.layers2 = [];



    this.source2 = new VectorSource({ wrapX: false });

    this.vector2 = new VectorLayer({

      source: this.source2,

    });

    if (this.bOfflineMap) {

      this.layers2.push(

        new TileLayer({

          source: new XYZ({

            url: this.strMapUrl,

            attributions: 'Map data © RayanAndishehNasr' //

          }),

        })

      );
    }

    else {

      const styles = [

        'AerialWithLabelsOnDemand',

      ];

      let i, ii;

      for (i = 0, ii = styles.length; i < ii; ++i) {
        this.layers2.push(
          new TileLayer({
            visible: false,
            preload: Infinity,
            source: new BingMaps({
              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

              imagerySet: styles[i],
            }),

          }),
        );
      }

      this.layers2.push(new TileLayer({ source: new OSM({}) }), this.vector2)
    }

    this.ctx8 = new Map({

      target: "InstallMap",

      view: new View({

        zoom: 4,

        center: olProj.fromLonLat([51.3833554, 35.6770113])

      }),

      layers: this.layers2

    });

    await this.clustersLayer2(res);


  }

  clustersLayer = async (data: any) => {


      this.ctx7.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(
          this.ctx7.getEventPixel(e.originalEvent),
          this.ctx7
        );


        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.ctx7.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;


    let addFeatures = (nb: any) => {
      var ext = this.ctx7.getView().calculateExtent(this.ctx7.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].fLon,
            data[i].fLat])

          ),
          id_: data[i].iPreregistration,
          data: {
            iPreregistration: data[i].iPreregistration,
            strfFullName: data[i].strfFullName,
          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.ctx7.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.ctx7.addInteraction(selectCluster);

  }

  clustersLayer2 = async (data: any) => {


      this.ctx8.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(
          this.ctx8.getEventPixel(e.originalEvent),
          this.ctx8
        );


        $("#link").click(() => {
          var tooltip = $('#install_map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.ctx8.getView().on('propertychange', function (e: any) {
        var tooltip = $('#install_map_tooltip');
        tooltip.tooltip('hide');
      });
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;


    let addFeatures = (nb: any) => {
      var ext = this.ctx8.getView().calculateExtent(this.ctx8.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].fInstall_Lon,
            data[i].fInstall_Lat])

          ),
          id_: data[i].iPreregistration,
          data: {
            iPreregistration: data[i].iPreregistration,
            strfFullName: data[i].strfFullName,
          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.ctx8.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.ctx8.addInteraction(selectCluster);

  }

}
